import request from '@/server/request'
export default {
  async loadRoadmapItems ({ rootGetters }) {
    return request({ entity: 'settings.landing.roadmap', action: 'list' }, rootGetters['admin/getAccessToken'], 'GET')
  },

  loadRoadmapItem ({ rootGetters }, payload) {
    return request({ entity: 'settings.landing.roadmap', action: 'get' }, rootGetters['admin/getAccessToken'], 'GET', payload)
  },

  create ({ rootGetters }, payload) {
    return request({ entity: 'settings.landing.roadmap', action: 'create' }, rootGetters['admin/getAccessToken'], 'POST', payload, false, true)
  },

  update ({ rootGetters }, payload) {
    return request({ entity: 'settings.landing.roadmap', action: 'update' }, rootGetters['admin/getAccessToken'], 'POST', payload, false, true)
  },

  delete ({ rootGetters }, payload) {
    return request({ entity: 'settings.landing.roadmap', action: 'delete' }, rootGetters['admin/getAccessToken'], 'DELETE', payload)
  },

  deleteImage ({ rootGetters }, payload) {
    return request({ entity: 'settings.landing.roadmap.image', action: 'delete' }, rootGetters['admin/getAccessToken'], 'DELETE', payload)
  },
}
